import React, { useEffect } from "react";
import commonStyles from "../../Shared/commonStyles.module.css";
import occasionStyles from "./Occasion.module.css";
import useOccasionsStore from "../../../Stores/useOccasionStore";
import { Link } from "react-router-dom";

function Occasion() {
  const { occasions, getOccasions } = useOccasionsStore();

  useEffect(() => {
    const fetchData = async () => {
      await getOccasions();
    };
    if (occasions.length === 0) {
      fetchData();
    }
  }, []);

  return (
    <section className={`${commonStyles.section} ${commonStyles.reveal}`}>
      <div className={commonStyles.container}>
        <span className={commonStyles.eyebrow}>Occasions</span>
        <h2>Find the right gift by occasion</h2>
        <p>Browse a curated selection of gifts for every occasion.</p>
        <div className={commonStyles.chips}>
          {occasions && occasions.length > 0 ? (
            occasions.map((occasion) => (
              <a
                key={occasion.Id}
                className={commonStyles.chip}
                href={`/occasions/${occasion.FriendlyName}`}
              >
                {occasion.Name}
              </a>
            ))
          ) : (
            <p>Loading occasions...</p>
          )}
        </div>
        <div className={commonStyles.heroCtas}>
          <Link to="/occasions" className={`${commonStyles.btn} ${commonStyles.btnPrimary}`}>
            
            Browse Occasions
          </Link>          
        </div>
      </div>
    </section>
  );
}

export default Occasion;
